import { useState, useEffect, useRef } from "react";
import { useTheme } from "../ThemeContext";
import { Card } from "../components/UI";

const API_PHP = "https://mixupbr.com.br/api/bot/index.php";
const H = { "Content-Type": "application/json", "X-Bot-Key": "mixupbot2026" };

export default function BotWhatsApp({ lojaId, nomeLoja }) {
  const { theme: C } = useTheme();
  const [status,   setStatus]   = useState("desconectado");
  const [qr,       setQr]       = useState(null);
  const [saudacao, setSaudacao] = useState("");
  const [link,     setLink]     = useState("");
  const [saving,   setSaving]   = useState(false);
  const [toast,    setToast]    = useState(null);
  const pollRef = useRef(null);

  const notify = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 2800); };

  const iS = { width: "100%", padding: "12px 14px", borderRadius: 10, border: `1px solid ${C.border}`, background: C.bg, color: C.text, fontSize: 14, fontFamily: "inherit", outline: "none" };
  const lS = { fontSize: 12, fontWeight: 600, color: C.textSoft, marginBottom: 6, display: "block" };

  // ── Carregar config e status ──
  useEffect(() => {
    const carregarTudo = async () => {
      try {
        const [rCfg, rLojas] = await Promise.all([
          fetch(`${API_PHP}?action=config`, { headers: H }).then(r => r.json()),
          fetch(`${API_PHP}?action=lojas`,  { headers: H }).then(r => r.json()),
        ]);
        if (rCfg.saudacao) setSaudacao(rCfg.saudacao);
        const lojas = Array.isArray(rLojas) ? rLojas : [];
        const loja  = lojas.find(l => String(l.id) === String(lojaId));
        if (loja?.link_catalogo) setLink(loja.link_catalogo);
      } catch {}
    };
    carregarTudo();

    const verificar = async () => {
      try {
        const r = await fetch(`${API_PHP}?action=bot_status&loja_id=${lojaId}`, { headers: H });
        const d = await r.json();
        setStatus(d.status || "desconectado");
        setQr(d.qrBase64 || null);
      } catch { setStatus("desconectado"); }
    };
    verificar();
    pollRef.current = setInterval(verificar, 3000);
    return () => clearInterval(pollRef.current);
  }, [lojaId]);

  const salvar = async () => {
    setSaving(true);
    try {
      await Promise.all([
        fetch(`${API_PHP}?action=salvar_config`, { method: "POST", headers: H, body: JSON.stringify({ saudacao }) }),
        fetch(`${API_PHP}?action=salvar_link_loja`, { method: "POST", headers: H, body: JSON.stringify({ id: lojaId, link_catalogo: link }) }),
      ]);
      notify("Configurações salvas!");
    } catch { notify("Erro ao salvar", false); }
    setSaving(false);
  };

  const conectar = async () => {
    try {
      await fetch(`${API_PHP}?action=bot_conectar`, { method: "POST", headers: H, body: JSON.stringify({ loja_id: lojaId, nome: nomeLoja, link_catalogo: link }) });
    } catch { notify("Erro ao conectar", false); }
  };

  const desconectar = async () => {
    if (!window.confirm("Desconectar o WhatsApp desta loja?")) return;
    try {
      await fetch(`${API_PHP}?action=bot_desconectar`, { method: "POST", headers: H, body: JSON.stringify({ loja_id: lojaId }) });
      setStatus("desconectado"); setQr(null);
      notify("WhatsApp desconectado");
    } catch { notify("Erro ao desconectar", false); }
  };

  const corStatus   = status === "conectado" ? C.greenLight : status === "aguardando_qr" ? "#f0a500" : C.red;
  const textoStatus = status === "conectado" ? "Conectado — respondendo automaticamente" : status === "aguardando_qr" ? "Aguardando leitura do QR Code" : "Desconectado";

  return (
    <div style={{ animation: "fadeUp .4s ease-out" }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontFamily: "'Plus Jakarta Sans'", fontWeight: 800, fontSize: 28 }}>Bot WhatsApp</h1>
      </div>

      {toast && <div style={{ position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)", zIndex: 999, background: toast.ok ? C.green : C.red, color: "#fff", padding: "12px 28px", borderRadius: 12, fontWeight: 700, fontSize: 14, animation: "slideDown .3s ease-out" }}>{toast.msg}</div>}

      {/* Conexão */}
      <Card>
        <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 20 }}>Conexão WhatsApp</h3>

        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20, padding: "14px 16px", borderRadius: 12, background: C.bg, border: `1px solid ${C.border}` }}>
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: corStatus, flexShrink: 0, boxShadow: status === "conectado" ? `0 0 8px ${corStatus}` : "none" }} />
          <span style={{ fontSize: 14, fontWeight: 600, color: corStatus }}>{textoStatus}</span>
        </div>

        {status === "aguardando_qr" && qr && (
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <img src={qr} alt="QR Code" style={{ width: 200, height: 200, borderRadius: 12, background: "#fff", padding: 8, border: `1px solid ${C.border}` }} />
            <p style={{ fontSize: 12, color: C.textMuted, marginTop: 10, lineHeight: 1.6 }}>
              Abra o WhatsApp no celular<br />Menu → Dispositivos conectados → Conectar dispositivo
            </p>
          </div>
        )}

        <div style={{ display: "flex", gap: 10 }}>
          {status === "desconectado" && (
            <button onClick={conectar} style={{ padding: "12px 24px", borderRadius: 10, border: "none", background: C.green, color: "#fff", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
              Conectar WhatsApp
            </button>
          )}
          {status === "aguardando_qr" && (
            <button onClick={conectar} style={{ padding: "12px 24px", borderRadius: 10, border: `1px solid ${C.border}`, background: "transparent", color: C.textSoft, fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
              Gerar novo QR
            </button>
          )}
          {status === "conectado" && (
            <button onClick={desconectar} style={{ padding: "12px 24px", borderRadius: 10, border: `1px solid ${C.red}40`, background: `${C.red}10`, color: C.red, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
              Desconectar
            </button>
          )}
        </div>
      </Card>

      {/* Configuração */}
      <Card>
        <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 20 }}>Configuração das Mensagens</h3>

        <div style={{ marginBottom: 16 }}>
          <label style={lS}>Link do Catálogo</label>
          <input value={link} onChange={e => setLink(e.target.value)} style={iS}
            placeholder="https://mixupbr.com.br/mixup-cliente/loja/1" />
          <span style={{ fontSize: 11, color: C.textMuted, marginTop: 4, display: "block" }}>
            Link enviado automaticamente quando um cliente manda mensagem.
          </span>
        </div>

        <div style={{ marginBottom: 20 }}>
          <label style={lS}>Mensagem de Boas-vindas</label>
          <textarea value={saudacao} onChange={e => setSaudacao(e.target.value)} rows={4}
            style={{ ...iS, resize: "vertical", lineHeight: 1.6 }}
            placeholder={"Olá! Bem-vindo!\n\nAcesse nosso cardápio pelo link abaixo:"} />
          <span style={{ fontSize: 11, color: C.textMuted, marginTop: 4, display: "block" }}>
            Use *negrito* e _itálico_ para formatar no WhatsApp.
          </span>
        </div>

        {/* Preview */}
        {(saudacao || link) && (
          <div style={{ marginBottom: 20, padding: "14px 16px", borderRadius: 12, background: C.bg, border: `1px solid ${C.border}` }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: C.textMuted, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>Preview</div>
            <div style={{ fontSize: 13, color: C.text, lineHeight: 1.7, whiteSpace: "pre-wrap" }}>
              {saudacao}{saudacao && link ? "\n\n" : ""}{link}
            </div>
          </div>
        )}

        <button onClick={salvar} disabled={saving} style={{ padding: 14, borderRadius: 12, border: "none", color: "#fff", fontWeight: 700, fontSize: 15, background: C.green, cursor: saving ? "wait" : "pointer", width: "100%", opacity: saving ? 0.7 : 1 }}>
          {saving ? "Salvando..." : "Salvar Configurações"}
        </button>
      </Card>
    </div>
  );
}
